import { Text, View } from '@react-pdf/renderer'

import { AmountKey } from '../../../enums/amountKey'
import { AmountCellsStyles } from '../styles/AmountCellStyles'
import { formatAmount } from '../utils/formatAmount'

export type AmountLineProps = {
  turnoverAmount?: number
  vatAmount?: number
  amountKeys: AmountKey[]
  fieldIndex: number
  locale?: string
  currency?: string
}

export const AmountLine = ({
  turnoverAmount,
  vatAmount,
  amountKeys,
  fieldIndex,
  locale,
  currency,
}: AmountLineProps) => {
  const amount = formatAmount({ value: turnoverAmount ?? vatAmount, locale, currency })

  return (
    <View style={AmountCellsStyles.amountsGroup}>
      {amountKeys.length === 0 ? (
        <Text style={AmountCellsStyles.amountText}>{amount}</Text>
      ) : (
        amountKeys.map((key, colIndex) => (
          <View key={`${fieldIndex}-${colIndex}-${key}`} style={AmountCellsStyles.amountColumn}>
            <Text style={AmountCellsStyles.amountText}>
              {formatAmount({
                value: key === AmountKey.Turnover ? turnoverAmount : vatAmount,
                locale,
                currency,
              })}
            </Text>
          </View>
        ))
      )}
    </View>
  )
}
